// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"a705aaab","453":"fe0d2943"}[chunkId] + ".chunk.js";
};